import type {PaletteMode} from '@mui/material';

export const getStylePropertyDemo = (
	key: string,
	mode: PaletteMode = 'light',
) => {
	const light = mode === 'light';
	switch (key) {
		case 'background':
		case 'surface':
			return light ? '#fafafa' : '#242424';
		case 'custom-backdrop':
			return light ? 'rgba(250, 250, 250, 0.85)' : 'rgba(36, 36, 36, 0.75)';
		case 'custom-background-accent':
			return light ? 'rgba(0, 0, 0, 0.02)' : 'rgba(255, 255, 255, 0.02)';
		case 'custom-background-light':
			return light ? 'rgba(0, 0, 0, 0.04)' : 'rgba(255, 255, 255, 0.04)';
		case 'custom-border':
			return light ? 'rgba(0, 0, 0, 0.08)' : 'rgba(255, 255, 255, 0.16)';
		case 'on-primary':
		case 'on-secondary':
			return '#fff';
		case 'primary':
		case 'secondary':
			return '#3884f8';
		case 'text-icon-on-background':
			return light ? 'rgba(0, 0, 0, 0.38)' : 'rgba(255, 255, 255, 0.87)';
		case 'text-primary-on-background':
		case 'text-secondary-on-background':
			return light ? 'rgba(0, 0, 0, 0.87)' : 'rgba(255, 255, 255, 0.87)';
	}
	return '';
};
